import { ReactNode } from 'react'
import { PageScroll } from 'app/components/layout/PageScroll'

export type AgentsLayoutShadcnComponentProps = {
  children: ReactNode
}

export function AgentsLayoutShadcnComponent({ children }: AgentsLayoutShadcnComponentProps) {
  return <PageScroll contentClassName="pt-8">{children}</PageScroll>
}
